const _scopedState = (state) => state.entities.chat;

const chatKitMethod = (state) => _scopedState(state).chatKitMethod;
const chatKitPayload = (state) => _scopedState(state).chatKitPayload;

export default {
  chatKitMethod,
  chatKitPayload,
};
